export default __webpack_public_path__ + "static/media/candolim beach.6077d958.jpg";